module.exports = __webpack_public_path__ + "static/media/laf_black.5a305c08.png";